export * from './baAppPicture.pipe';



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/pipes/baAppPicture/index.ts